import { usePathname } from 'src/routes/hooks';

import MetaHead from 'src/utils/metaHead';

import { frontEndUrl } from 'src/server/http';
import saleBanner from 'src/assets/images/specialSale/staticBannerMobile.webp';

import SpecialSaleListView from 'src/sections/specialSale/specialSaleList/special-sale-list';

export default function SpecialSalePage() {
  const path = usePathname();
  const canonicalUrl = frontEndUrl + path;

  return (
    <>
      <MetaHead
        canonical={canonicalUrl}
        title="Hot Deals & Discounts in Oman – Top Offers, Sales & Promo Codes"
        description="Shop the best online deals in Oman! Get top discounts and exclusive offers on electronics, home appliances, and more. Limited-time sales with fast delivery across Oman!"
        keywords=""
        openGraph={{
          title: 'Hot Deals',
          description:
            'Shop the best online deals in Oman! Get top discounts and exclusive offers on electronics, home appliances, and more. Limited-time sales with fast delivery across Oman!',
          image: {
            url: saleBanner,
          },
        }}
        twitter={{
          title: 'Hot Deals',
          description:
            'Shop the best online deals in Oman! Get top discounts and exclusive offers on electronics, home appliances, and more. Limited-time sales with fast delivery across Oman!',
          image: {
            url: saleBanner,
          },
        }}
      />
      <SpecialSaleListView />
    </>
  );
}
